import {BaseCachedService} from './Core/BaseCachedService';

class SurveyQuestionDataTypeService extends BaseCachedService {
    get Url() { return super.Url + "/surveyQuestionDataTypes"; }
}

export const service = new SurveyQuestionDataTypeService();

